import React from 'react';

export const NoteText = (
  <>
    <br />
    <br />
    <strong>Note:</strong> Neighborhood Grade compares neighborhoods within this market. It shows
    how this area performs against other parts of the same market.
  </>
);

export const getMarketGradeTooltip = (marketGrade: string | null) => {
  if (!marketGrade)
    return 'Neighborhood grade is only available for verified neighborhoods and areas with 25 or more listings.';

  if (marketGrade === 'processing') {
    return 'This neighborhood is currently being processed. Please check back in 5 mins.';
  }

  if (marketGrade.startsWith('A')) {
    return (
      <span>
        This neighborhood ranks in the top 16% of the market, earning a significantly higher premium
        over the average.
        {NoteText}
      </span>
    );
  }
  if (marketGrade.startsWith('B')) {
    return (
      <span>
        This neighborhood ranks between the top 16–32% of the market, earning a higher-than-average premium.
        {NoteText}
      </span>
    );
  }
  if (marketGrade.startsWith('C')) {
    return (
      <span>
        This neighborhood ranks in the mid-range of the market, with values close to the average.
        {NoteText}
      </span>
    );
  }
  if (marketGrade.startsWith('D')) {
    return (
      <span>
        This neighborhood ranks below the market average, with lower premiums than most areas.
        {NoteText}
      </span>
    );
  }
  if (marketGrade.startsWith('E')) {
    return (
      <span>
        This neighborhood ranks in the bottom 32% of the market, earning lower premiums than the average.
        {NoteText}
      </span>
    );
  }
  if (marketGrade.startsWith('F')) {
    return (
      <span>
        This neighborhood ranks in the bottom 16% of the market, earning significantly lower premiums than the average.
        {NoteText}
      </span>
    );
  }
  return '';
};
